import { STORE_HOST_SUFFIX } from '../config/runtimeConfig';
import { RESERVED_SUBDOMAINS } from './storeUtils';

export const STORE_SLUG_MIN_LENGTH = 3;
export const STORE_SLUG_MAX_LENGTH = 30;
export const STORE_SLUG_FALLBACK = 'myshop';

export const getStoreSlugHostSuffix = () => STORE_HOST_SUFFIX || '.salovare.com';

export const formatStoreSlugHost = (slug) => {
  if (!slug) {
    return '';
  }

  return `${slug}${getStoreSlugHostSuffix()}`;
};

export const slugifyStoreName = (value) => {
  if (!value || !String(value).trim()) {
    return STORE_SLUG_FALLBACK;
  }

  const slug = String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '')
    .slice(0, STORE_SLUG_MAX_LENGTH);

  return slug.length < STORE_SLUG_MIN_LENGTH ? STORE_SLUG_FALLBACK : slug;
};

export const sanitizeSlugInput = (value) => String(value || '')
  .toLowerCase()
  .replace(/[^a-z0-9-]/g, '')
  .slice(0, STORE_SLUG_MAX_LENGTH);

export const getSlugFormatErrorKey = (slug) => {
  const value = String(slug || '').trim();
  if (!value) {
    return 'storeRegistration.validation.slugRequired';
  }

  if (value.length < STORE_SLUG_MIN_LENGTH) {
    return 'storeRegistration.validation.slugTooShort';
  }

  if (value.length > STORE_SLUG_MAX_LENGTH) {
    return 'storeRegistration.validation.slugTooLong';
  }

  if (
    value.startsWith('-')
    || value.endsWith('-')
    || value.includes('--')
    || !/^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(value)
  ) {
    return 'storeRegistration.validation.slugInvalid';
  }

  if (RESERVED_SUBDOMAINS.has(value)) {
    return 'storeRegistration.validation.slugReserved';
  }

  return null;
};

export const getSlugAvailabilityErrorKey = (reason) => {
  if (reason === 'reserved') {
    return 'storeRegistration.validation.slugReserved';
  }

  if (reason === 'taken') {
    return 'storeRegistration.validation.slugTaken';
  }

  return 'storeRegistration.validation.slugInvalid';
};
